import { render } from "./tariffCard.vue?vue&type=template&id=4c81ff7e"
import script from "./tariffCard.vue?vue&type=script&lang=js"
export * from "./tariffCard.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./tariffCard.vue?vue&type=style&index=0&id=4c81ff7e&module=true&lang=less"
cssModules["$style"] = style0
import "./tariffCard.vue?vue&type=style&index=1&id=4c81ff7e&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__